'use strict';

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _select = require('./select');

var _handle = require('./handle');

var _ls = require('./ls');

var _require = require('./constants'),
    PROTOCOL_ID = _require.PROTOCOL_ID;

exports.PROTOCOL_ID = PROTOCOL_ID;

var MultistreamSelect = /*#__PURE__*/function () {
  function MultistreamSelect(stream) {
    _classCallCheck(this, MultistreamSelect);

    this._stream = stream;
    this._shaken = false;
  } // Perform the multistream-select handshake


  _createClass(MultistreamSelect, [{
    key: "_handshake",
    value: function () {
      var _handshake2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$select, stream;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._shaken) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _select(this._stream, PROTOCOL_ID);

              case 4:
                _yield$select = _context.sent;
                stream = _yield$select.stream;
                this._stream = stream;
                this._shaken = true;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _handshake() {
        return _handshake2.apply(this, arguments);
      }

      return _handshake;
    }()
  }]);

  return MultistreamSelect;
}();

var Dialer = /*#__PURE__*/function (_MultistreamSelect) {
  _inherits(Dialer, _MultistreamSelect);

  var _super = _createSuper(Dialer);

  function Dialer() {
    _classCallCheck(this, Dialer);

    return _super.apply(this, arguments);
  }

  _createClass(Dialer, [{
    key: "select",
    value: function select(protocols) {
      return _select(this._stream, protocols, this._shaken ? null : PROTOCOL_ID);
    }
  }, {
    key: "ls",
    value: function () {
      var _ls2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$_ls, stream, protocols;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._handshake();

              case 2:
                _context2.next = 4;
                return _ls(this._stream);

              case 4:
                _yield$_ls = _context2.sent;
                stream = _yield$_ls.stream;
                protocols = _yield$_ls.protocols;
                this._stream = stream;
                return _context2.abrupt("return", protocols);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ls() {
        return _ls2.apply(this, arguments);
      }

      return ls;
    }()
  }]);

  return Dialer;
}(MultistreamSelect);

exports.Dialer = Dialer;

var Listener = /*#__PURE__*/function (_MultistreamSelect2) {
  _inherits(Listener, _MultistreamSelect2);

  var _super2 = _createSuper(Listener);

  function Listener() {
    _classCallCheck(this, Listener);

    return _super2.apply(this, arguments);
  }

  _createClass(Listener, [{
    key: "handle",
    value: function handle(protocols) {
      return _handle(this._stream, protocols);
    }
  }]);

  return Listener;
}(MultistreamSelect);

exports.Listener = Listener;